<template>
  <div class="exhibitionDetail">
    <div class="swiper">
      <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
      <!-- @change="onChange" :initial-swipe="params.index" -->
      <van-swipe @change="onChange">
        <van-swipe-item v-for="i in exhibitList"> <img :src="i.picUrl" alt="" class="swiper_img" /> </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{ exhibitList.length }}</div>
        </template>
      </van-swipe>
    </div>
    <div class="content">
      <div class="title">{{ detailInfo.name }}</div>
      <div class="author" v-if="detailInfo.author">作者：{{ detailInfo.author }}</div>
      <div v-if="detailInfo.detail">
        概述：
        {{ detailInfo.detail }}
      </div>
    </div>
  </div>
</template>
<script>
import { getExhibitItemDetails, getExhibit } from '@/api/exhibition'
export default {
  name: 'exhibitionDetail',
  data() {
    return {
      current: 0,
      detailInfo: {},
      exhibitList: [],
      params: {
        exhibitId: '',
        page: 1,
        size: 10,
      },
    }
  },
  methods: {
    onChange(index) {
      console.log('index==============>', index)
      this.getDetail(this.exhibitList[index].id)
      this.current = index
    },
    back() {
      this.$router.go(-1)
    },
    getDetail(id) {
      getExhibitItemDetails(id).then((res) => {
        this.detailInfo = res.result
      })
    },
  },
  mounted() {
    console.log(this.$route.query.id)
    console.log('index==========>', this.$route.query.index)

    this.params.exhibitId = this.$route.query.id
    this.params.index = this.$route.query.index
    getExhibit(this.params).then((res) => {
      console.log('res11111111111============>', res)
      this.total = res.result.total
      this.exhibitList = res.result.records
      this.getDetail(res.result.records[this.params.index].id)
    })
  },
}
</script>
<style lang="scss" scoped>
.exhibitionDetail {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  .swiper {
    width: 100%;
    height: 18.75rem;
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 48px;
      // top: calc(40px + env(safe-area-inset-top));
    }
    .swiper_img {
      width: 100%;
      height: 18.75rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 0.95rem;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .content {
    position: absolute;
    top: 18.2rem;
    left: 0;
    width: 100%;
    padding: 1.65rem 0.6rem;
    border-radius: 0.6rem 0.6rem 0 0;
    background: #fff;
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    &::before {
      content: '';
      display: inline-block;
      width: 2rem;
      height: 5px;
      background: #cccc;
      border-radius: 3px;
      position: absolute;
      left: calc(50% - 1rem);
      top: 0.6rem;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .author {
      margin: 0.8rem 0 0.4rem 0;
    }
  }
}
</style>
